/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/


$( document ).ready(function() {
   $('.model-popup-cls').click(function(){
        $('.popup').toggle('slow');
    });
    $("#toggle").click(function() {
      $("#toggle").css("display","none");
      $("#closebtn").css("display","block");
      $(".gm-bordered.gm-mobile-bordered").slideToggle();
      $(".page-width ul").removeClass('gm-menu');
      $('.site-header__section site-header__section--button serch-btn').css("display","block");
      $('.search-button btn btn--clear btn--square').css("display","block");
      $('.site-header__section--button').css("display","block");
      $('.site-header__section--title').css("display","none");
      //$('.site-header__logo-image').removeClass('logo-img-class');
  });


    $("#closebtn").click(function() {
      $("#closebtn").css("display","none");
      $("#toggle").css("display","block");
      $(".page-width ul").addClass('gm-menu').css("display","none");
      $('.site-header__section site-header__section--button serch-btn').css("display","block");
      $('.site-header__section--button').css("display","none");
      $('.site-header__section--title').css("display","block");
  });

  $("h3").click(function(){
    $(this).next("ul").toggleClass("test");
});
  
$('.image-selector').lightzoom({
  zoomPower   : 3,
  glassSize   : 200
});
  

});


$("[data-target]").on('click', function(){
   var target_  = $(this).attr("data-target");
   var targetSelector = $(target_);
   if(targetSelector.length){
      $("html, body").animate({ scrollTop: targetSelector.offset().top }, 1000);
   }
})

